import CodeScanner from "./CodeScanner";

export default CodeScanner;
